export const APP_INSTALL = 'APP_INSTALL';
